import "fetch-polyfill";
import Vue from "vue";
Vue.config.productionTip = false;
import App from "./App.vue";
import "./assets/font/iconfont.css";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import router from "./router";
import store from "./store";
import "./utils/rem";
import "./utils/tool";

import { Message } from "element-ui";
import ElementUI from "./element-config";
import { Input } from "element-ui";
import 'default-passive-events';

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "./assets/css/element-variables.scss";
import "./assets/css/element-change.scss";
import muIcon from "./components/mu-icon.vue";
import clientChip from "./components/chip.vue";
import userAvatar from "./components/userAvatar";
import star from "./components/star";
import api from "./api";
import moment from "moment";
import whiteList from "./utils/whiteList";
import { GetLanguageByApp } from "@/api/config";
const xss = require("xss");

let myXss = new xss.FilterXSS({ whiteList, css: false });
// import waterfall from "vue-waterfall2";
// Vue.use(waterfall);
//多语言
import VueI18n from "vue-i18n";
import "@/assets/icons"
Vue.use(VueI18n);

import elementEnLocale from "element-ui/lib/locale/lang/en"; // element-ui lang
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN"; // element-ui lang
import { translate, getOrigin } from "./utils/util";

//禁止路由报错
import Routers from "vue-router";
const routerPush = Routers.prototype.push;
Routers.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
//防止多次点击按钮调用接口
Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        el.classList.add("disabled");
        setTimeout(() => {
          el.disabled = false;
          el.classList.remove("disabled");
        }, binding.value || 2000);
      }
    });
  },
});

Vue.component("MuIcon", muIcon);
Vue.component("UserAvatar", userAvatar);

Vue.component("ClientChip", clientChip);
Vue.component("Star", star);

// 时间格式化，默认为中文 其他全显示英文状态
// moment.locale(lang == "" || lang == "zh" ? "zh-cn" : "");

const i18n = new VueI18n({
  locale: store.getters.getLanguage,
  silentTranslationWarn: true,
  ...elementEnLocale,
  ...elementZhLocale,
});

// Vue.use(VueI18n);
// locale.use(lang == "zh" ? elementZhLocale : elementEnLocale);
// /**请求language的语言包接口 */
const loadLanguage = async () => {
  await GetLanguageByApp().then((res) => {
    if (res && res.isSuccess && res.data && res.data.language) {
      /**请求完成之后重新setLanguage */
      for (let key in res.data.language) {
        if (key == "en") {
          i18n.setLocaleMessage("en", {
            ...res.data.language[key],
            ...elementEnLocale,
          });
        } else if (key == "zh") {
          i18n.setLocaleMessage("zh", {
            ...res.data.language[key],
            ...elementZhLocale,
          });
        } else {
          i18n.setLocaleMessage(key, {
            ...res.data.language[key],
            ...elementEnLocale,
          });
        }
      }
    } else {
      Message("语言包获取失败，请确认网络链接和服务器资源");
    }
  });
};

loadLanguage();

Vue.use(ElementUI);
Vue.prototype.$api = api;
Vue.prototype.$xss = myXss;
Vue.prototype.$moment = moment;
Vue.prototype.$translate = translate;
Vue.prototype.$getOrigin = getOrigin;

Vue.component("ElInput", {
  extends: Input,
  created() {
    this.$on("change", (value) => {
      if (Object.prototype.toString.call(value) === "[object String]") {
        if (value.trim() === "") {
          this.$emit("input", "");
        } else {
          this.$emit("input", value.trim());
        }
      }
    });
  },
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
